<template>
  <section class="position-relative pt-3 colorTemplateBack" id="Info">
    <div class="container mb-0 mt-10">
      <div class="row text-center">
        <h1 class="text-center display-2"> Start jouw SKWINKELHier.</h1>
        <h2 class="fw-bold mb-10">Vlakbij de mijne, waar anders?!</h2>
        <p class="lead text-center text-md-start text-muted mb-6 mb-lg-8 fontSpecial">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'BannerPanden'
}
</script>

<style>
.colorTemplateBack{
  background-color: rgb(248, 248, 248);
}
</style>